import styled from 'styled-components'
import { margin } from '@styled-system/space'

import { ResponsiveContainer } from 'recharts'

export const Container = styled(ResponsiveContainer)`
  ${margin}
`
